(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('MessageManager', [
        '$log',
        '$timeout',
        '$rootScope',
        '$q',
        'MessageProvider',
        'AppConstants',
        MessageManager
    ]);

    function MessageManager ($log, $timeout, $rootScope, $q, MessageProvider, AppConstants) {
        var messageManager = {},
            errorTypes = AppConstants.ErrorTypes,
            ERROR_DELAY_CLOSE_FOR_ACTIONABLE_MESSAGE = 5000,
            ERROR_DELAY_CLOSE = 2500;

        $rootScope.messages = {
            Offset: 0,
            Messages: []
        };

        function constructMessage (type, message, folders, documents) {
            // Default parameters
            folders = folders || [];
            documents = documents || [];
            return {
                type: type,
                defered : $q.defer(),
                message: message,
                date: (new Date()).toLocaleString(),
                folders: folders,
                documents: documents,
                closed: false
            };
        }

        messageManager.resetAllMessages = function () {
            $rootScope.messages = {
                Offset: 0,
                Messages: []
            };
        };

        messageManager.getMessages = function () {
            return $rootScope.messages;
        };

        messageManager.removeMessage = function (index) {
            $rootScope.messages.Messages.splice(index, 1);
            messageManager.filterMessages();
        };

        messageManager.filterMessages = function () {
            if (!$rootScope.messages.Messages || $rootScope.messages.Messages.length === 0) {
                $rootScope.messages = {
                    Messages: [],
                    Offset: {'max-height': 0 }
                };
                return;
            }

            var messages = $rootScope.messages.Messages.slice(),
                filtered_messages = [messages[0]],
                message_index = 1, // Track messages
                filtered_index = 0; // Track filtered_messages

            // If current element and next elements are both delete or uploads, then roll into current element
            for (; message_index < messages.length; message_index++) {
                if (filtered_messages[filtered_index].type ===  messages[message_index].type) {
                    if (filtered_messages[filtered_index].type === errorTypes.UPLOAD) {
                        filtered_messages[filtered_index].documents = filtered_messages[filtered_index].documents.concat(messages[message_index].documents);
                        if(filtered_messages[filtered_index].documents.length > 0) {
                            filtered_messages[filtered_index].message = MessageProvider.folderBulkUploadFailDefault(filtered_messages[filtered_index].documents);
                        }
                    }
                    else if (filtered_messages[filtered_index].type === errorTypes.TRANSIENT_ERROR) {
                        // When the error type is transient, dont add to the messages list
                    }
                    else if (filtered_messages[filtered_index].type === errorTypes.DELETE) {
                        filtered_messages[filtered_index].documents = filtered_messages[filtered_index].documents.concat(messages[message_index].documents);
                        filtered_messages[filtered_index].folders = filtered_messages[filtered_index].folders.concat(messages[message_index].folders);

                        if (filtered_messages[filtered_index].documents.length && filtered_messages[filtered_index].folders.length) {
                            filtered_messages[filtered_index].message = MessageProvider.folderBulkDeleteDocumentsAndFoldersFail(filtered_messages[filtered_index].documents, filtered_messages[filtered_index].folders);
                        } else if (filtered_messages[filtered_index].documents.length) {
                            filtered_messages[filtered_index].message = MessageProvider.folderBulkDocumentDeleteFail(filtered_messages[filtered_index].documents);
                        } else {
                            filtered_messages[filtered_index].message = MessageProvider.folderBulkFolderDeleteFail(filtered_messages[filtered_index].folders);
                        }
                    }
                    else {
                        // Dissimilar message types
                        filtered_messages.push(messages[message_index]);
                        filtered_index ++;
                    }
                }
                else {
                    // Dissimilar message types between
                    filtered_messages.push(messages[message_index]);
                    filtered_index ++;
                }
            }

            if(!!filtered_messages){
                $rootScope.messages = {
                    Messages: filtered_messages
                };
                if (!$rootScope.$$phase) {
                    $rootScope.$digest();
                }
            }
        };

        messageManager.addSuccessMessage = function (message, containsActionableLink) {
            var m = constructMessage(errorTypes.SUCCESS, message);
            $rootScope.messages.Messages.push(m);
            if (!containsActionableLink) {
                messageManager.filterMessages();
            }
            messageManager.delayedRemoveSuccess(m, containsActionableLink);
            //Return a promise that'll be resolved when user clicks the message
            return m.defered.promise;
        };

        messageManager.addFreMessage = function (message) {
            var m = constructMessage(errorTypes.FRE, message);
            $rootScope.messages.Messages.push(m);
            messageManager.filterMessages();
            messageManager.delayedRemoveSuccess(m);
        };

        messageManager.addInfoMessage = function (message, containsActionableLink) {
            var m = constructMessage(errorTypes.INFO, message);
            $rootScope.messages.Messages.push(m);
            messageManager.filterMessages();
            messageManager.delayedRemoveSuccess(m, containsActionableLink);
            //Return a promise that'll be resolved when user clicks the message
            return m.defered.promise;
        };

        messageManager.addErrorUploadMessage = function (message, folders, documents) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.UPLOAD, message, folders, documents));
            messageManager.filterMessages();
        };

        messageManager.addErrorMoveMessage = function (message) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.MOVE, message));
            messageManager.filterMessages();
        };

        messageManager.addErrorDeleteMessage = function (message, folders, documents) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.DELETE, message, folders, documents));
            messageManager.filterMessages();
        };

        messageManager.addErrorShareMessage = function (message) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.SHARE, message));
            messageManager.filterMessages();
        };

        messageManager.addTransientErrorMessage = function (message) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.TRANSIENT_ERROR, message));
            messageManager.filterMessages();
        };

        messageManager.addErrorMessage = function (message) {            
            $rootScope.messages.Messages.push(constructMessage(errorTypes.DEFAULT, message));
            messageManager.filterMessages();
        };

        messageManager.addErrorIEMessage = function (message) {
            $rootScope.messages.Messages.push(constructMessage(errorTypes.IE, message));
            messageManager.filterMessages();
        };

        messageManager.clearTransientMessages = function () {
            for (var i = 0; i < $rootScope.messages.Messages.length; i++) {
                if ($rootScope.messages.Messages[i].type === errorTypes.TRANSIENT_ERROR) {
                    messageManager.removeMessage(i);
                }
            }
        };

        messageManager.delayedRemoveSuccess = function (element, containsActionableLink) {
            $timeout(function () {
                element.closed = true;
            }, containsActionableLink ? ERROR_DELAY_CLOSE_FOR_ACTIONABLE_MESSAGE : ERROR_DELAY_CLOSE);
        };

        return messageManager;
    }

}());
